"use client"

import {
  analysisImg,
  deploymentImg,
  dotsAnimation,
  executionImg,
  testingImg,
} from '@/assets/imgs'
import SingleProcess from './SingleProcess'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

type Props = {
  className?:string
}

const Process = ({className}:Props) => {
  const  t  = useTranslations()
  return (
    <>
      <div className={`${className}`}>
        <div className='relative flex flex-col flex-wrap items-center justify-center gap-5 pb-10'>
          <p className='w-fit rounded-full bg-lightBlue px-7 py-2 text-sm uppercase rtl:text-base rtl:font-semibold'>
            {t('aboutPage.process')}
          </p>
          <h3 className='text-3xl font-bold leading-snug sm:text-4xl'>
            {t('aboutPage.ourWorkingProcess')}
          </h3>
          <Image
          alt='dots'
            src={dotsAnimation}
            className='absolute -top-20 right-6 w-28 animate-bounce animate-direction-alternate animate-duration-3000 animate-iteration-infinite animate-ease-linear sm:right-28 lg:-top-10 lg:right-16'
          />
        </div>
        <div className='flex flex-wrap justify-center gap-9 px-6 sm:px-14 md:px-16'>
          <SingleProcess
            img={analysisImg}
            title={t('aboutPage.analysis')}
          />
          <SingleProcess
            img={executionImg}
            title={t('aboutPage.execution')}
          />
          <SingleProcess
            img={testingImg}
            title={t('aboutPage.testing')}
          />
          <SingleProcess
            img={deploymentImg}
            title={t('aboutPage.deployment')}
          />
        </div>
      </div>
    </>
  )
}

export default Process
